var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M12.0746 0C5.40968 0 0 5.39857 0 12.0635C0 15.4848 1.45517 18.7506 3.99894 21.05C5.54298 18.0064 8.66438 16.0958 12.0746 16.0958C9.29754 16.0958 7.04258 13.8408 7.04258 11.0637C7.04258 8.2867 9.29754 6.03174 12.0746 6.03174C14.8516 6.03174 17.1066 8.2867 17.1066 11.0637C17.1066 13.8408 14.8516 16.0958 12.0746 16.0958C15.4848 16.0958 18.6062 18.0064 20.1502 21.05C25.1045 16.5956 25.5155 8.9643 21.0611 3.99894C18.7617 1.45517 15.4959 0 12.0746 0Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 16.0957C14.8541 16.0957 17.107 13.8428 17.107 11.0637C17.107 8.28464 14.8541 6.03174 12.075 6.03174C9.29587 6.03174 7.04297 8.28464 7.04297 11.0637C7.04297 13.8428 9.29587 16.0957 12.075 16.0957Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.0501C6.26607 16.5958 11.7091 14.8074 16.1746 17.0734C17.8852 17.9399 19.2737 19.3395 20.1513 21.0501",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInformation);
export default __webpack_public_path__ + "static/media/userInformation.5e41cfb5daf396d8952ac9de886effb7.svg";
export { ForwardRef as ReactComponent };